import React, { useState, useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Container,
  Backdrop,
  CircularProgress,
  Grid,
  Button,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { UserDataContext } from "../Contexts/UserDataContext";
import toll_logo from "../tge-logo-lockup-dark-fern-rgb.svg";
import TextFieldAdvanceOnEnter from "./TextFieldAdvanceOnEnter";
import version from "../version.json";
import MfaDialog from "./MfaDialog";
import  SurveyMessage from './survey/newSurvey.jsx'
import { 
  surveyTitle, 
  currentSurveyLink,
  surveyStartDate,
  surveyEndDate
} from './survey/surveyDetails'

const mailTo = "nationaltransportcompliance@teamglobalexp.co.nz";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  field: {
    padding: theme.spacing(2),
    textAlign: "left",
  },
  header: {
    padding: theme.spacing(2),
    textAlign: "center",
  },
  headerIcon: {
    width: "100%",
    textAlign: "center",
    padding: theme.spacing(2),
  },
  feedback: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: "red",
  },
  forgotPassword: {
    paddingTop: theme.spacing(2),
    textAlign: "center",
  },
  svg: {
    height: "auto",
    width: "100%",
    
  },
  version: {
    position: "absolute",
    right: "5px",
    bottom: "5px",
  },
}));

const LoginPage = (props) => {
  const { ...otherProps } = props;
  const { userData, login } = useContext(UserDataContext);
  const history = useHistory();
  const [formValues, setFormValues] = useState({
    username: "",
    password: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  

    const authenticate = async () => {
    try {
      console.log("logging in");
      setLoading(true);
      await login(formValues.username, formValues.password, setErrorMessage);

      console.log(userData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    authenticate();
  };

  const currDate = new Date()
  const [isShowSurvey, setisShowSurvey] = useState(currDate >= surveyStartDate && currDate < surveyEndDate);

  const openSurvey = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  
  const closeSurvey = () => {
    setisShowSurvey(false);
  }

  useEffect(() => {
    setLoading(false);
    if (userData.loggedIn) {
      history.push(`/${userData.userName}/dashboard`);
    }
  }, [userData, history]);

  return (
    <>
      <Typography variant="caption" className={classes.version}>
        {version.commit.substring(0, 7)} {process.env.REACT_APP_ENV}
      </Typography>

      <MfaDialog />
      <Container maxWidth="sm" className={classes.container} {...otherProps}>
        <Grid container justify="center" alignItems="flex-start">
          <Grid item className={classes.headerIcon} xs={12}>
            <img src={toll_logo} alt="toll logo" className={classes.svg} width />
          </Grid>
          <Grid item className={classes.header} xs={12}>
            <Typography variant="h5" className={classes.text}>
              Team Global Express NZ Owner Driver Portal
            </Typography>
          </Grid>
          <Grid item className={classes.field} xs={12}>
            <TextFieldAdvanceOnEnter
              onChange={(event) =>
                setFormValues({ ...formValues, username: event.target.value })
              }
              fullWidth
              placeholder="Enter username"
              type="text"
            />
          </Grid>
          <Grid item className={classes.field} xs={12}>
            <TextFieldAdvanceOnEnter
              onChange={(event) =>
                setFormValues({ ...formValues, password: event.target.value })
              }
              onEnter={() => authenticate()}
              fullWidth
              placeholder="Enter password"
              type="password"
            />
          </Grid>
          <Grid item className={classes.field} xs={12}>
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="primary"
              onClick={handleClick}
              disabled={loading}
            >
              Log in
            </Button>
          </Grid>
          {errorMessage && (
            <Grid item className={classes.feedback} xs={12}>
              <Typography variant="body1">{errorMessage}</Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography className={classes.forgotPassword} variant="body1">
              For any technical issues, including password resets, please
              contact Helpdesk 0800 006 206 or{" "}
              <Link to={'mailto:'+ mailTo}>
                {mailTo}
              </Link>
              <br />
              For any other queries, please escalate to your Branch
              Administrator
            </Typography>
          </Grid>
        </Grid>
      </Container>
      {loading && (
        <Backdrop open>
          <CircularProgress size={120} />
        </Backdrop>
      )}
      <SurveyMessage
        show={isShowSurvey}
        title={surveyTitle}
        confirmButtonText='Yes'
        cancelButtonText='No'
        onCancel={() => closeSurvey()}
        onConfirm={() => {
          closeSurvey()
          openSurvey(currentSurveyLink)
        }}
      />
    </>
  );
};

export default LoginPage;
